import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link as RouterLink } from 'react-router-dom';
import ImportPanel from './components/ImportPanel';

/**
 * Dedicated CSV import screen. It deliberately does NOT auto-return to the table:
 * the result summary (incl. any errors / partial success) stays on screen until
 * the user navigates back via "Back to orders".
 */
export default function ImportPage() {
  return (
    <Box sx={{ p: { xs: 2, md: 3 }, maxWidth: 900, mx: 'auto' }}>
      <Button component={RouterLink} to="/orders" startIcon={<ArrowBackIcon />} size="small" sx={{ mb: 2 }}>
        Back to orders
      </Button>
      <Typography variant="h4" gutterBottom>
        Import orders
      </Typography>
      <ImportPanel />
    </Box>
  );
}
